export default {
  'meta': {
    'langName': 'SPANISH',
    'lang': 'Español'
  },
  'title': 'RETIRADA DE PRODUCTO CANASTA DE BALONCESTO B900 BOX NBA TARMAK',
  'description': 'Hola,\n\nHace poco ha comprado una canasta de baloncesto Tarmak B900 BOX NBA y le agradecemos su compra.\n\nComo parte de nuestro compromiso continuo con la calidad y la seguridad de nuestros productos, el equipo de baloncesto de DECATHLON ha identificado un riesgo de caída vertical del poste si se retira la manivela de ajuste de altura y se usa o manipula el producto.\n\nLe rogamos que responda a algunas preguntas para que podamos proporcionarle la solución de seguridad adecuada para su producto.\n\nSentimos las molestias ocasionadas y le agradecemos su confianza.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'En primer lugar, ¿podría confirmar su dirección de correo electrónico y su país de residencia?'
  },
  'fields': {
    'country': 'País',
    'address': 'Correo electrónico',
    'email': 'Correo electrónico',
    'phonePrefix': 'Prefijo telefónico',
    'phone': 'Número de teléfono',
    'validations': {
      'phoneOrEmail': 'Proporcione al menos una dirección de correo electrónico o un número de teléfono.',
      'email': 'Introduzca una dirección de correo válida',
      'phone': 'Introduzca un número de teléfono válido'
    },
    'firstName': 'Apellido',
    'lastName': 'Nombre',
    'deliveryAddress': 'Dirección para la entrega del paquete',
    'additionalAddress': 'Datos adicionales para la dirección de entrega',
    'city': 'Cuidad',
    'zip': 'Código portal',
    'choose': 'Seleccionar',
    'required': 'Este campo es obligatorio'
  },
  'ownerCheck': {
    'title': '¿Todavía tiene una o varias canastas de baloncesto NBA B900 BOX?'
  },
  'yes': 'SÍ',
  'no': 'NO',
  'ownerChanged': {
    'title': '¿Tiene los datos de contacto del propietario o propietarios actuales?',
    'confirmation': 'Apreciado/a Sr./Sra:\n\nGracias por participar en esta iniciativa de calidad.\n\nLe pedimos disculpas por las molestias ocasionadas y le agradecemos su confianza.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Indique el número de canastas de baloncesto que tiene, según el tipo de manivela instalada',
    'descriptionRed': 'Canasta de baloncesto con manivela roja extraíble',
    'descriptionBlack': 'Canasta de baloncesto con manivela fija negra',
    'quantity': 'Cantidad',
    'notConcerned': 'Apreciado/a Sr./Sra:\n\nGracias por participar en esta iniciativa de calidad.\n\nPuede tener la seguridad de que su canasta de baloncesto Tarmak B900 BOX NBA no se ha visto afectada por el proceso de retirada. Su uso es seguro.\n\nSentimos las molestias ocasionadas y le agradecemos su confianza.\n\nDECATHLON',
    'concernedProductQuantity': 'Cantidad de productos no conformes:',
    'concernedProductLabel': 'Producto no conforme:',
    'confirmation': 'Gracias por rellenar este formulario. Su solicitud se ha registrado correctamente.\n\nLe enviaremos el número de seguimiento de la entrega de su kit a la mayor brevedad posible (a través de FandiWeb para los países europeos / a través de X para los países no europeos).\n\nEsperamos que tenga un buen día.\nDECATHLON'
  },
  'repair': {
    'title': 'Reparación con su participación',
    'description': 'Hemos detectado un riesgo de caída vertical del poste si se retira la manivela y se manipula o usa el producto en determinadas canastas de baloncesto TARMAK B900 BOX NBA, ref. 4239136.\nEn base a su respuesta, su producto parece estar afectado por este riesgo.\n\nPor ello, le rogamos que deje de usarlo inmediatamente y nos ofrecemos a ayudarle a adaptar la manivela para que pueda usar el producto de forma segura.\nTenga la seguridad de que para hacer esta reparación no es necesario tener conocimientos especiales: todo está claramente explicado en el vídeo y en el manual de instrucciones que encontrará a continuación:',
    'videoLink': 'Enlace al vídeo',
    'docLink': 'Enlace al aviso',
    'callToAction': 'Haga clic aquí para recibir su kit de reparación gratuito',
    'warranty': 'Todo el proceso está cubierto por nuestra garantía de 5 años.'
  },
  'repairRequest': {
    'title': 'Introduzca la siguiente información para que podamos enviarle su kit gratuito a la dirección que desee:'
  },
  'form': {
    'submit': 'Siguiente'
  },
  'status': 'Translation validated by COUNTRY'
} as const
